import * as React from 'react';
import isFunction from 'lodash/isFunction';

import ContentGalleryContext from '../../../context/ContentGalleryContext';

import type {
  GalleryModalItem
} from 'types';
import type {
  ContentGalleryItem
} from '../../../types';

type Props = {
  selectedItem: GalleryModalItem,
  items: Array<ContentGalleryItem> | undefined
};

const ContentGalleryThumbnailOverlay: React.FunctionComponent<Props> = ({
  selectedItem,
  items
}: Props) => {
  const context = React.useContext(ContentGalleryContext);
  const renderGalleryThumbnailOverlay = context?.renderGalleryThumbnailOverlay;

  if (!isFunction(renderGalleryThumbnailOverlay)) {
    return null;
  }

  return (
    <div className="content-gallery-thumbnail-overlay">
      {renderGalleryThumbnailOverlay(selectedItem, items)}
    </div>
  );
};

export default ContentGalleryThumbnailOverlay;
